import { DefaultButton, Modal, Text, Stack, Icon } from "@fluentui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { PatientPicker } from "../PatientPicker/PatientPicker";
import { useClinicalFilters } from "../../clinicalContext";
import { useLogin } from "../../authConfig";
import { SHOW_SUMMARIES } from "../../featureFlags";

// Pages that don't require a patient (not patient-specific)
const PATIENT_NOT_REQUIRED_PATHS = ["/caseload", "/clinical-lab", "/qa", "/help"];

interface PatientRequiredModalProps {
    showPatientPicker?: boolean;
}

export const PatientRequiredModal = ({ showPatientPicker = true }: PatientRequiredModalProps) => {
    const { filters } = useClinicalFilters();
    const location = useLocation();
    const navigate = useNavigate();
    const { accounts, inProgress } = useMsal();
    const isAuthenticated = !useLogin || (accounts.length > 0 && inProgress === "none");
    const onExemptPage = PATIENT_NOT_REQUIRED_PATHS.some(p => location.pathname === p || location.pathname.startsWith(p + "/"));
    // Don't show blocking modal until user is authenticated (so Login button is accessible)
    // Nosum app is caseload-centric — never show patient picker modal
    const isOpen = SHOW_SUMMARIES && isAuthenticated && !filters.patId && !onExemptPage;

    return (
        <Modal
            isOpen={isOpen}
            isBlocking={true}
            styles={{
                main: {
                    maxWidth: 420,
                    width: "90vw",
                    padding: 32,
                    borderRadius: 12,
                    textAlign: "center",
                    overflow: "visible"
                },
                scrollableContent: {
                    overflow: "visible"
                }
            }}
        >
            <Stack tokens={{ childrenGap: 20 }} horizontalAlign="center">
                <Icon iconName="SearchBookmark" styles={{ root: { fontSize: 40, color: "#0078d4" } }} />
                <Text variant="xLarge" block styles={{ root: { fontWeight: 600 } }}>
                    Select a patient to get started
                </Text>
                <Text variant="medium" block styles={{ root: { color: "#555" } }}>
                    {showPatientPicker ? "Type at least 2 characters to search by name" : "Open Caseload and choose a patient."}
                </Text>
                {showPatientPicker ? (
                    <div style={{ width: "100%", maxWidth: 300 }}>
                        <PatientPicker variant="modal" />
                    </div>
                ) : (
                    <DefaultButton text="Open Caseload" onClick={() => navigate("/caseload")} />
                )}
            </Stack>
        </Modal>
    );
};
